import { MdDelete } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import { Campus_Table_Model } from "../../Models/CampusModel";
import { useDispatch } from "react-redux";
import { CAMPUS_SINGLE_DATA } from "../../Actions/campusAction";

export default function CampusTableRow({
  Campus_Id,
  Campus_Name,
  Country,
  University_Name,
  handleEditCampusData,
  handleDeleteCampus,
}) {
  const data = ["delete", Campus_Name, University_Name, Country];
  const dispatch = useDispatch();
  const handleEdit = (e) => {
    e.preventDefault();
    dispatch(CAMPUS_SINGLE_DATA(Campus_Id));
    handleEditCampusData(Campus_Id);
  };
  // Handle Delete Table function
  const handleDelete = (e) => {
    e.preventDefault();
    handleDeleteCampus(Campus_Id);
  };

  return (
    <tr>
      {Campus_Table_Model?.map((el, i) => (
        <td key={i}>
          {data[i] === "delete" ? (
            <span className={data[i] === "delete" ? "Edit_Delete" : ""}>
              <span onClick={(e) => handleEdit(e)}>
                <TbEdit />
              </span>
              <span onClick={handleDelete}>
                <MdDelete />
              </span>
            </span>
          ) : (
            data[i]
          )}
        </td>
      ))}
    </tr>
  );
}
